module.exports = __webpack_public_path__ + "static/media/location-pin.93655984.svg";